// src/data/detailedServicesData.js

export const detailedServicesData = [
  {
    id: "cat-sites",
    categoryTitle: "Création de Sites Web",
    plans: [
      {
        id: "site-basique",
        title: "Basique",
        subtitle: "Idéal pour les petites entreprises et startups.",
        price: "À partir de €879",
        priceSuffix: "projet unique",
        features: [
          "Site web vitrine (jusqu'à 5 pages)",
          "Design responsive",
          "Hébergement 1 an inclus",
          "Formulaire de contact",
        ],
      },
      {
        id: "site-standard",
        title: "Standard",
        subtitle: "Pour une présence digitale optimisée.",
        price: "À partir de €1599",
        priceSuffix: "projet unique",
        features: [
          "Site web dynamique (CMS type WordPress ou custom)",
          "Design sur-mesure & responsive",
          "Hébergement 1 an inclus",
          "Optimisation SEO de base",
          "Blog intégré",
        ],
      },
      {
        id: "site-premium",
        title: "Premium",
        subtitle: "Solution complète pour une présence digitale puissante.",
        price: "À partir de €2899",
        priceSuffix: "projet unique",
        features: [
          "Site web dynamique / Application web simple",
          "Design sur-mesure et responsive avancé",
          "Intégration de fonctionnalités complexes (ex: espace membre)",
          "Intégration d'une base de données",
          "Hébergement 1 an inclus",
          "SEO avancé & stratégie de contenu",
        ],
      },
    ],
  },
  {
    id: "cat-hebergement",
    categoryTitle: "☁️ Hébergement Web",
    plans: [
      {
        id: "heb-basique",
        title: "Basique",
        subtitle: "Hébergement avec support de base.",
        price: "À partir de €69",
        priceSuffix: "/an",
        features: [
          "Sauvegardes automatiques (hebdomadaires)",
          "Certificat SSL inclus",
          "2 adresses e-mail professionnelles",
          "2 Go de stockage SSD",
          "Support technique standard",
        ],
      },
      {
        id: "heb-standard",
        title: "Standard",
        subtitle: "Hébergement avec support avancé.",
        price: "À partir de €189",
        priceSuffix: "/an",
        features: [
          "Sauvegardes automatiques (journalières)",
          "Certificat SSL inclus",
          "10 adresses e-mail professionnelles",
          "5 Go de stockage SSD",
          "Support technique prioritaire",
        ],
      },
      {
        id: "heb-premium",
        title: "Premium",
        subtitle: "Hébergement avec support premium.",
        price: "À partir de €299",
        priceSuffix: "/an",
        features: [
          "Sauvegardes automatiques (journalières, rétention étendue)",
          "Certificat SSL Premium",
          "50+ adresses e-mail professionnelles",
          "20+ Go de stockage SSD NVMe",
          "Support dédié et infogérance basique",
        ],
      },
    ],
  },
  {
    id: "cat-maintenance",
    categoryTitle: "🛡️ Maintenance & Support",
    plans: [
      {
        id: "maint-basique",
        title: "Basique (Intervention Ponctuelle)",
        subtitle: "Mises à jour et corrections.",
        price: "À partir de €45",
        priceSuffix: "/heure",
        features: [
          "Mises à jour de sécurité et techniques",
          "Correction de bugs mineurs",
          "Développement web & mobile (sur devis horaire)",
        ],
      },
      {
        id: "maint-standard",
        title: "Standard (Pack Mensuel)",
        subtitle: "Maintenance complète et support premium.",
        price: "À partir de €199",
        priceSuffix: "/mois",
        features: [
          "Support technique avancé (email & téléphone)",
          "Mises à jour régulières (core, thèmes, plugins)",
          "Surveillance de sécurité et performance",
          "Interventions prioritaires (jusqu'à X heures incluses)",
        ],
      },
      {
        id: "maint-premium",
        title: "Premium (Accompagnement Continu)",
        subtitle: "Maintenance sur-mesure et optimisation continue.",
        price: "À partir de €499",
        priceSuffix: "/mois",
        features: [
          "Support dédié avec interlocuteur unique",
          "Mises à jour proactives et monitoring avancé",
          "Ajout de petites fonctionnalités et optimisations",
          "Optimisation continue (SEO technique, performance)",
          "Reporting mensuel détaillé",
        ],
      },
    ],
  },
  {
    id: "cat-apps",
    categoryTitle: "📱 Applications Mobiles",
    plans: [
      {
        id: "app-basique",
        title: "Basique (MVP)",
        subtitle: "Application native ou hybride pour démarrer.",
        price: "À partir de €899",
        priceSuffix: "projet unique",
        features: [
          "Design intuitif (basé sur guidelines)",
          "Fonctionnalités essentielles (1-2 écrans clés)",
          "Développement iOS ou Android (ou hybride)",
          "Support de base pour le lancement",
        ],
      },
      {
        id: "app-standard",
        title: "Standard",
        subtitle: "Application personnalisée avec fonctionnalités avancées.",
        price: "À partir de €2599",
        priceSuffix: "projet unique",
        features: [
          "Interface utilisateur sur-mesure",
          "Fonctionnalités étendues (multi-écrans, interactions)",
          "Développement iOS et Android (ou hybride poussé)",
          "Support premium et aide à la publication",
        ],
      },
      {
        id: "app-premium",
        title: "Premium",
        subtitle: "Application sur-mesure avec intégration complète.",
        price: "À partir de €4499",
        priceSuffix: "projet unique",
        features: [
          "Développement sur-mesure complexe",
          "Intégration d'API tierces, notifications push",
          "Backend et base de données si nécessaire",
          "Maintenance continue (optionnelle)",
          "Accompagnement stratégique",
        ],
      },
    ],
  },
  {
    id: "cat-refonte",
    categoryTitle: "🔄 Refonte & Optimisation de Sites",
    plans: [
      {
        id: "refonte-basique",
        title: "Basique (Audit & Lifting)",
        subtitle: "Audit complet et redesign partiel.",
        price: "À partir de €399",
        priceSuffix: "projet unique",
        features: [
          "Audit SEO et technique complet",
          "Recommandations d'amélioration",
          "Redesign partiel (ex: page d'accueil, éléments clés)",
          "Optimisation de la vitesse de base",
        ],
      },
      {
        id: "refonte-standard",
        title: "Standard (Refonte Complète)",
        subtitle: "Refonte complète et intégration moderne.",
        price: "À partir de €799",
        priceSuffix: "projet unique",
        features: [
          "Refonte graphique complète (design sur-mesure)",
          "Intégration sur CMS ou framework moderne",
          "Optimisation SEO et performance",
          "Tests de compatibilité et performance",
        ],
      },
      {
        id: "refonte-premium",
        title: "Premium (Transformation Stratégique)",
        subtitle: "Refonte sur-mesure avec support post-lancement.",
        price: "À partir de €1299",
        priceSuffix: "projet unique",
        features: [
          "Analyse stratégique et refonte complète (design & dev)",
          "Migration de contenu et redirection",
          "Optimisation SEO avancée et UX",
          "Support post-lancement et formation",
        ],
      },
    ],
  },
  {
    id: "cat-graphisme",
    categoryTitle: "🎨 Création Graphique & Supports",
    plans: [
      {
        id: "logo-creation",
        title: "Création de Logo Professionnel",
        subtitle: "Une identité visuelle unique pour votre marque.",
        price: "À partir de €299",
        priceSuffix: "unique",
        features: [
          "Recherche et concepts créatifs",
          "Plusieurs propositions de logo",
          "Révisions incluses",
          "Livraison des fichiers sources (AI, SVG, PNG)",
        ],
      },
      {
        id: "supports-com",
        title: "Supports de Communication",
        subtitle: "Cartes de visite, flyers, plaquettes, etc.",
        price: "Sur devis",
        priceSuffix: "",
        features: [
          "Design sur mesure de vos supports",
          "Adaptation à votre charte graphique",
          "Préparation des fichiers pour l'impression",
          "Conseils sur les choix de matériaux et finitions",
        ],
      },
    ],
  },
  {
    id: "cat-multimedia",
    categoryTitle: "📸 Production Photo & Vidéo",
    plans: [
      {
        id: "photo-pro",
        title: "Photographie Professionnelle",
        subtitle: "Photos produits, portraits d'équipe, reportages entreprise.",
        price: "Sur devis",
        priceSuffix: "",
        features: [
          "Shooting photo sur site ou en studio",
          "Retouche professionnelle des images",
          "Adaptation des formats pour le web et print",
          "Cession des droits d'utilisation",
        ],
      },
      {
        id: "video-promo",
        title: "Vidéo Promotionnelle",
        subtitle: "Clips vidéo pour présenter votre entreprise, vos produits ou services.",
        price: "Sur devis",
        priceSuffix: "",
        features: [
          "Conception et scénarisation",
          "Tournage (matériel professionnel, drone si besoin)",
          "Montage, étalonnage, sound design",
          "Optimisation pour diffusion web et réseaux sociaux",
        ],
      },
    ],
  },
];